export default __webpack_public_path__ + "e12ddeb3ebf232429d833296eebcecde.ttf";